module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS6.0ab051d8.jpg";